import OverlayTrigger from "@rio-cloud/rio-uikit/OverlayTrigger";
import Tooltip from "@rio-cloud/rio-uikit/Tooltip";

interface LabelProps {
    centerX: number;
    boundsHeight: number;
    name: string;
}

const MAX_CHARS = 12;

export const Label = ({ centerX, boundsHeight, name }: LabelProps) => {
    const displayName =
        name?.length > MAX_CHARS ? name.slice(0, MAX_CHARS) + "..." : name ?? "";

    const textY = boundsHeight + 35;

    return (
        <OverlayTrigger
            key={crypto.randomUUID()}
            placement="bottom"
            overlay={
                <Tooltip id="tooltip" allowOnTouch>
                    {name}
                </Tooltip>
            }
        >
            <text
                x={centerX}
                y={textY}
                textAnchor="end"
                fontSize={10}
                fill="#999"
                transform={`rotate(-45, ${centerX}, ${textY})`}
                style={{
                    cursor: "pointer",
                    userSelect: "none",
                }}
            >
                {displayName}
            </text>
        </OverlayTrigger>
    );
};
